const { wlGlobalConfig } = window;
export const ENV = wlGlobalConfig.__environment;
export const SITE_URL = wlGlobalConfig.__site_url;
export const AJAX_URL =
  ENV === 'development' || ENV === 'review'
    ? `${SITE_URL}/wp/wp-admin/admin-ajax.php?action=`
    : `${SITE_URL}/wp-admin/admin-ajax.php?action=`;
export const UPLOADS_URL = wlGlobalConfig.__uploads_url;
export const STRIPE_API_KEY = wlGlobalConfig.__stripe_api_key;
export const COOP_ID = wlGlobalConfig.__coop_id;
export const COOP_NAME = wlGlobalConfig.__coop_name;
export const TAXONOMY = wlGlobalConfig.__taxonomy;
export const TEMPLATE = wlGlobalConfig.__template;
export const ALGOLIA_APP_ID = wlGlobalConfig.__algolia_app_id;
export const ALGOLIA_SEARCH_KEY = wlGlobalConfig.__algolia_search_key;
export const ALGOLIA_INDEX_PREFIX = wlGlobalConfig.__algolia_prefix;
